import {
	AddressWithContactInfo,
	AddressWithContactInfoResponse,
	CountryCode,
	RegionCode,
} from '../SharedModels';

export interface PartialOrganization {
	id: number;
	type?: OrganizationType;
	name: string | null;
	logoSrc: string;
}

export interface FullOrganization extends PartialOrganization {
	address: AddressWithContactInfo;
}

export interface FullOrganizationResponse extends Omit<PartialOrganization, 'id' | 'type'> {
	id: number | string;
	type: string;
	address: AddressWithContactInfoResponse;
}

export interface CreateOrganizationRequest {
	type: string;
	name: string;
	address: {
		street1: string;
		street2: string;
		city: string;
		province: RegionCode;
		country: CountryCode;
		postal: string;
		contactInfo: {
			phone: string;
			fax?: string;
		};
	};
}

export enum OrganizationType {
   ALLIED_HEALTH = 'organization.type.allied-health',
   BIOTECHNOLOGY = 'organization.type.biotechnology',
   DENTAL = 'organization.type.dental',
   DIAGNOSTIC_SERVICE_PROVIDER = 'organization.type.diagnostic-service-provider',
   EDUCATIONAL_INSTITUTE = 'organization.type.educational-institute',
   FAMILY_MEDICINE = 'organization.type.family-medicine',
   GOVERNMENT = 'organization.type.government',
   HEALTH_SCIENCES = 'organization.type.health-sciences',
   HOME_HEALTH_CARE = 'organization.type.home-health-care',
   HOSPITAL = 'organization.type.hospital',
   INSURANCE = 'organization.type.insurance',
   LONG_TERM_CARE = 'organization.type.long-term-care',
   MEDICAL_EQUIPMENT = 'organization.type.medical-equipment',
   MEDICAL_LABORATORY = 'organization.type.medical-laboratory',
   MEDICAL_LEGAL_CLAIM = 'organization.type.medical-legal-claim',
   MEDICAL_PUBLISHERS = 'organization.type.medical-publishers',
   MENTAL_HEALTHCARE = 'organization.type.mental-healthcare',
   NOT_FOR_PROFIT_FOUNDATIONS_AND_ASSOCIATIONS = 'organization.type.not-for-profit-foundations-and-associations',
   PHARMACEUTICAL = 'organization.type.pharmaceutical',
   PHARMACY = 'organization.type.pharmacy',
   REHABILITATION = 'organization.type.rehabilitation',
   SELF_EMPLOYMENT = 'organization.type.self-employment',
   SPECIALTY_MEDICINE = 'organization.type.specialty-medicine',
   THERAPY_WELLNESS_CLINIC = 'organization.type.therapy-wellness-clinic',
   WALK_IN_CARE = 'organization.type.walk-in-care',
   OTHER = 'organization.type.other',
}
